<template>
    <div style="display: flex;    padding-right: 40px;">
        <button class="button is-small is-disabled has-text-primary trigger-bill" v-if="!car.zoho_id" @click="triggerBill">B</button>
        <button class="button is-small is-primary trigger-bill" v-else>B</button>
        <button class="button is-small is-disabled has-text-info trigger-invoice" v-if="invoice !== null && !invoice.zoho_id" @click="triggerInvoice">I</button>
        <button class="button is-small is-info trigger-invoice" v-else>I</button>
    </div>
</template>

<script>
    export default {
        props:['car', 'invoice'],
        computed: {
            hasPaid() {
                let percent = (this.car.proforma_invoice.paid_amount / this.car.proforma_invoice.balance_due) * 100

                 if (percent < 30) {
                    return 'is-danger'
                } else if (percent >= 30 && percent < 50) {
                    return 'is-warning'
                } else if (percent >= 50 && percent < 100) {
                    return 'is-purple'
                } else {
                    return 'is-success'
                }
            },
            balance() {
                if (this.car.proforma_invoice !== null) {
                    let balance = this.car.proforma_invoice.balance_due - this.car.proforma_invoice.paid_amount
                    if (balance  > 0) {
                        return balance
                    } else {
                        return 'PAID'
                    }
                } else {
                    return false
                }
            },
            currency() {
                if (this.car.proforma_invoice.currency == this.$currencyIsJpy ) {
                    return '¥'
                } else {
                    return '$'
                }
            }
        },
        methods: {
            triggerBill() {
                this.$store.dispatch('setCarAlertDetails', {carAlertMessage: 'Trigger Bill to ZOHO ?', carAlertModalStatus: true, carObj: this.car, triggerType: 'zoho_bill', isResponse: false})
                console.log('triggering bill');
            },
            triggerInvoice() {
                this.$store.dispatch('setCarAlertDetails', {carAlertMessage: 'Trigger Invoice to ZOHO ?', carAlertModalStatus: true, carObj: this.car, triggerType: 'zoho_invoice', isResponse: false})
                console.log('triggering invoice');
            }
        }
    }
</script>

<style scoped>
    .button {
        min-width: 90px;
    }
    .trigger-bill{
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .is-purple {
        background-color: #ff00f1;
        border-color: transparent;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ActionColumn.vue